export default function setAppName(useCase) {
    if (useCase?.title) {
        window.document.title = useCase?.title;
    }
}
